import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import {getToken} from '../cache'

Vue.use(Router)

// const router = new Router({routes,mode:'history'})
const router = new Router({routes,mode:'hash'})
router.beforeEach((to, from, next) => {
    let token = getToken();
    console.log('token:',token);
    const title = to.meta && to.meta.title || 'MOVIE后台管理'
    if(title)
    {
        document.title = title;
    }


    if (token) {
        next()
    } else {
        if (to.path === '/login') {
            next()
        } else {
            next('/login')
        }
    }
});

export default router;
